/* CR47 cart extras — in-drawer add for the cross-sell and gift forms.
   Progressive enhancement only: without this file every form is a normal POST to /cart/add.
   It never listens to, delays or changes the checkout button. */
(() => {
  if (window.__nmCartExtras) return;
  window.__nmCartExtras = true;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-nm-cart-add]');
    if (!form) return;
    const drawer = form.closest('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // cart page form: let the POST happen
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      const body = new FormData(form);
      body.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
      body.append('sections_url', window.location.pathname);
      const res = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST', body, headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const data = await res.json();
      if (!res.ok || data.status) { form.submit(); return; } // fall back to the plain POST path
      drawer.renderContents(data);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nm-cart-extras', productVariantId: body.get('id'), cartData: data });
      }
    } catch (err) {
      form.submit();
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  });
})();

/* CR76 round 3: the shopper's own viewing history, used only to order the cart cross-sell.
   On a product page the handle is remembered in this browser (localStorage, last 12, newest first).
   When the cross-sell renders, items the shopper already looked at move to the front; the CSS shows the
   first two. Nothing is sent anywhere: the list never leaves the browser. If Shopify's Customer Privacy
   API is present and says preference storage is not allowed, nothing is written. */
(() => {
  const KEY = 'nm_rv';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };

  const m = location.pathname.match(/\/products\/([^/?#]+)/);
  const privacy = window.Shopify && window.Shopify.customerPrivacy;
  const allowed = !(privacy && typeof privacy.preferencesProcessingAllowed === 'function') || privacy.preferencesProcessingAllowed();
  if (m && allowed) {
    const handle = decodeURIComponent(m[1]);
    const list = [handle, ...read().filter((h) => h !== handle)].slice(0, 12);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private window */ }
  }

  const sort = () => {
    const seen = read();
    if (!seen.length) return;
    document.querySelectorAll('[data-nm-xsell] .nm-xsell__list:not([data-nm-sorted])').forEach((ul) => {
      ul.setAttribute('data-nm-sorted', '');
      const items = [...ul.children];
      const rank = (li) => { const i = seen.indexOf(li.dataset.nmHandle); return i < 0 ? seen.length : i; };
      items.map((li, i) => [rank(li), i, li]).sort((a, b) => a[0] - b[0] || a[1] - b[1]).forEach(([, , li]) => ul.appendChild(li));
    });
  };
  sort();
  // The drawer's contents are replaced on every add, so sort again whenever a fresh list appears.
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(sort).observe(drawer, { childList: true, subtree: true });
})();

/* CR76 r3b: the offer button names the chosen size ("Add · M"), so the shopper sees exactly what one tap adds.
   (r6: the size row now wraps, so nothing needs scrolling into view.) */
(() => {
  const sync = (root) => root.querySelectorAll('[data-nm-xsell] input:checked').forEach((input) => {
    const label = input.nextElementSibling;
    const btn = input.form && input.form.querySelector('[data-nm-add-label]');
    const text = label && `${btn ? btn.dataset.nmAddLabel : ''} · ${label.textContent.trim()}`;
    if (btn && label && btn.textContent !== text) btn.textContent = text; // guard: the observer below would loop on every write
  });
  document.addEventListener('change', (e) => { if (e.target.closest('[data-nm-xsell]')) sync(e.target.form || document); });
  sync(document);
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(() => sync(drawer)).observe(drawer, { childList: true, subtree: true });
})();

/* CR76 r3b: long carts pushed the offer card out of sight. While the card is below the visible part of
   the drawer's scroll area, the link under the reward bar shows the card's heading and jumps to it. */
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || !('IntersectionObserver' in window)) return;
  let io;
  const wire = () => {
    const jump = drawer.querySelector('[data-nm-offer-jump]');
    const card = drawer.querySelector('[data-nm-xsell]');
    if (io) io.disconnect();
    if (!jump) return;
    if (!card) { jump.hidden = true; return; }
    const heading = card.querySelector('.nm-xsell__heading');
    const text = heading ? heading.textContent.replace(/\s+/g, ' ').trim() : 'Pairs with it';
    if (jump.textContent !== text) jump.textContent = text;
    io = new IntersectionObserver(([e]) => { jump.hidden = e.isIntersecting || e.boundingClientRect.top < e.rootBounds.top; },
      { root: drawer.querySelector('cart-drawer-items'), threshold: 0.15 });
    io.observe(card);
    if (!jump.dataset.nmWired) {
      jump.dataset.nmWired = '1';
      jump.addEventListener('click', (ev) => { ev.preventDefault(); const c = drawer.querySelector('[data-nm-xsell]'); const box = drawer.querySelector('cart-drawer-items');
        // Scroll only the item list, so the cart heading and reward bar stay in place.
        if (c && box) box.scrollTo({ top: box.scrollTop + c.getBoundingClientRect().top - box.getBoundingClientRect().top - 8, behavior: 'smooth' }); });
    }
  };
  wire();
  new MutationObserver((list) => { if (list.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-nm-xsell], [data-nm-offer-jump]') || n.querySelector && n.querySelector('[data-nm-xsell], [data-nm-offer-jump]'))))) wire(); })
    .observe(drawer, { childList: true, subtree: true });
})();

/* CR76 r7: the Shopify Inbox chat button (bottom right) sat on top of the size buttons, "Size guide" and the hero's
   "Get notified" on a phone. While it would cover one of those controls, it tucks just below the screen edge; it
   comes back as soon as nothing important is underneath. It never moves while the chat window is open. */
(() => {
  const KEY = 'variant-selects label, .nm-size-help__link, .product-form__submit, .nm-hero__cta, .nm-showcase__size, .nm-showcase__notify-btn, .nm-vrow__item.is-active .nm-vrow__plus, .nm-vrow__item.is-active .nm-vrow__toggle';
  let raf = 0;
  const check = () => {
    raf = 0;
    const host = document.querySelector('shopify-chat');
    const root = host && host.shadowRoot;
    if (!root) return;
    const open = [...root.querySelectorAll('[role="dialog"], iframe')].some((e) => e.getBoundingClientRect().height > 200);
    const btn = [...root.querySelectorAll('button, [role="button"]')].find((b) => b.getBoundingClientRect().width > 0);
    if (!btn || open) { host.classList.remove('nm-chat-tucked'); return; }
    const tucked = host.classList.contains('nm-chat-tucked');
    const c = btn.getBoundingClientRect();
    const top = tucked ? c.top - 96 : c.top; // judge by where the button sits when not tucked
    const hit = [...document.querySelectorAll(KEY)].some((e) => { const r = e.getBoundingClientRect();
      return r.width > 0 && r.right > c.left - 8 && r.left < c.right + 8 && r.bottom > top - 8 && r.top < top + c.height + 8; });
    host.classList.toggle('nm-chat-tucked', hit);
  };
  const queue = () => { if (!raf) raf = requestAnimationFrame(check); };
  // CR94: capture, so a sideways swipe inside the video row (its own scroller) is heard too.
  addEventListener('scroll', queue, { passive: true, capture: true });
  addEventListener('resize', queue);
  addEventListener('nm:vrow-active', queue);
  setTimeout(check, 1500); setTimeout(check, 4000);
})();

/* CR76 r7: "Recently viewed" at the bottom of product pages (competitor scan: Kith, Represent). Uses the same
   in-browser history as the cart offer (nm_rv); nothing is sent anywhere except the storefront's own product
   JSON requests. Sold-out products and this product are skipped; up to 4 cards; the row stays hidden if none. */
(() => {
  const box = document.querySelector('[data-nm-rv]');
  if (!box) return;
  let seen = [];
  try { seen = JSON.parse(localStorage.getItem('nm_rv')) || []; } catch (e) { return; }
  const handles = seen.filter((h) => h && h !== box.dataset.current).slice(0, 8);
  if (!handles.length) return;
  const money = (cents) => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const load = () => Promise.all(handles.map((h) => fetch(`${root}products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)))
    .then((list) => {
      const items = list.filter((p) => p && p.available && p.featured_image).slice(0, 4);
      if (!items.length) return;
      box.querySelector('ul').innerHTML = items.map((p) => {
        const img = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (p.featured_image.includes('?') ? '&' : '?') + 'width=360';
        return `<li class="nm-rv__item"><a href="${esc(p.url)}" class="nm-rv__link"><img src="${esc(img)}" alt="" width="360" height="360" loading="lazy" class="nm-rv__img"><span class="nm-rv__name">${esc(p.title)}</span><span class="nm-rv__price">${esc(money(p.price))}</span></a></li>`;
      }).join('');
      box.hidden = false;
    });
  ('requestIdleCallback' in window ? requestIdleCallback : setTimeout)(load);
})();
